const catalogMenu = $('.nav-menu');
let viewportWidth = document.documentElement.clientWidth;
let initMobileMenu;

$(window).resize(function () {
  viewportWidth = document.documentElement.clientWidth;
  mobileMenu();
});

mobileMenu();
showMenu();

function showMenu() {
  // Show menu
  $('.js-toggle-menu').on('click', function (e) {
    e.stopPropagation();
    $(this).toggleClass('active');
    $('body').toggleClass('no-scroll');
    $('.nav').toggleClass('active');
  });

  if (viewportWidth > 1023) {
    $('.js-toggle-menu').removeClass('active');
    $('body').removeClass('no-scroll');
    $('.nav').removeClass('active');
  }
}

function mobileMenu() {
  if (viewportWidth < 1024 && !initMobileMenu) {

    // Open catalog
    $('.js-show-catalog').on('click', function (e) {
      e.preventDefault();
      $(this).fadeOut(10);
      $('.nav__link').fadeOut();
      catalogMenu.fadeIn();
    });

    // Close catalog
    $('.nav-menu__back').on('click', function () {
      $('.js-show-catalog').fadeIn(100);
      $('.nav__link').fadeIn(10);
      catalogMenu.fadeOut(100);
    });

    // Open about complex
    $('.js-show-complex').on('click', function () {
      $(this).fadeOut(10);
      $('.nav__item--menu').fadeOut(10);
      $('.nav__list').addClass('nav__list--no-column');
      $('.nav__link').fadeOut(10);
      $('.nav__drop').fadeIn();
    });

    // Close about complex
    $('.nav__drop-back').on('click', function () {
      $('.nav__item--menu').fadeIn(10);
      $('.nav__list').removeClass('nav__list--no-column');
      $('.nav__link').fadeIn(10);
      $('.nav__drop').fadeOut(100);
    });

    if (viewportWidth < 768) {

      // Accordeon
      $('.nav-menu__title--drop').on('click', function (e) {
        e.preventDefault();

        const $this = $(this);
        const content = $this.closest('.nav-menu__item').find('.nav-menu__list');
        const otherContent = $('.nav-menu').find('.nav-menu__list');

        if (!$this.hasClass('active')) {
          $('.nav-menu__col').siblings().find('.nav-menu__title--drop').removeClass('active');
          $this.addClass('active');
          otherContent.stop(true, true).slideUp();
          content.stop(true, true).slideDown();
        } else {
          $this.removeClass('active');
          content.stop(true, true).slideUp();
        }
      });
    }
    initMobileMenu = true;

  } else if (viewportWidth >= 768 && initMobileMenu) {
    $('.nav-menu__title--drop').off('click');
    $('.nav-menu__list').fadeIn();
    initMobileMenu = false;
  }
}

$(window).on('load', function () {
  $('.nav-menu').removeClass('js-hide-onload');
});